import AutocompleteLocation from './AutocompleteLocation.component';
export default AutocompleteLocation;